import React,{Component} from 'react';
import {Line} from 'react-chartjs-2';
import { Button } from 'react-bootstrap';
import './Body.css';

class CurveLineChart extends Component
{
  
  constructor() {
    super();
    this.state = {
      lineChartData: []
    }
    this.data0 = this.data0.bind(this);
  }


      
  
  componentDidMount() {
    this.data0();
    }


    data0(){
      this.setState({
        lineChartData:{
          labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          datasets: [
          {
            label:'Total Request',
            data: [7, 8, 9, 10, 11 ],
            fill:  true,
            borderWidth: 2,
            lineTension:0.25, 
            borderColor: ['rgba(255,206,86,0.2)'],
            backgroundColor: ['rgba(255,206,86,0.2)'],
            pointBackgroundColor: 'rgba(255,206,86,0.2)',
            pointBorderColor: 'rgba(255,206,86,0.2)'
          },
          
        ]
      }
     })
    }
   
   

  render() {
    console.log(this.props)
    const options={
       maintainAspectRatio: true,
        responsive: true,
         plugins: {
            legend: {
              position: 'bottom',
              align: 'start',
                labels: {
                  color: 'black',
                  padding :5,
                  boxWidth: 100,
                  usePointStyle: true,
                  pointStyle: 'circle',
                     font: {
                        size: 10,


                    }
                }
            }
        },
        layout: {
            padding: 5
        },
    scales:{
       y: {
               beginAtZero: true,
               ticks:{
          stepSize: 1,
          color: 'black'
        }
            },
        x: {
               ticks:{
          color: 'black'
        }
            }
         }
      }
    return (
      <>
      <div className="btnsclass">
          <Button onClick={this.data1} variant ="flat" className="linegraphbutton">Last 6 Months</Button>
      </div>
          <Line data={this.state.lineChartData} options={options} />
      </>
  )
  }
}

export default CurveLineChart;